import React from 'react';
import { Button, ButtonSizes, Icon, Icons, MultilineInput } from '@silverfort/sf-components';
import { httpGet } from '../utils';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            loginInProgress: false,
            loginFailed: false,
            saasSupportSsoServerPath: '/login/saasSupport',
            saasLoginComment: ''
        };
    }

    componentDidMount() {
        httpGet('/login/options')
            .then((response) => {
                const responseData = response.data;
                if (!responseData.saasMode) {
                    document.location.href = '/login';
                }
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    saasSupportLoginHandler = () => {
        const query = {
            loginComment: this.state.saasLoginComment.replace(/\n/g, '\\n')
        };
        document.location.href = `${this.state.saasSupportSsoServerPath}?${new URLSearchParams(query).toString()}`;
    };

    render() {
        if (this.state.loading) {
            return (
                <div id="login">
                    <div className="silverfort-loader">
                        <div className="logo"></div>
                    </div>
                </div>
            );
        }

        return (
            <div id="login" className="bg-black h-screen">
                <Icon icon={Icons.SilverfortLogo} className="fill-sf-white h-10 w-38 pl-8 pt-8" />

                <div className="container flex flex-col justify-center items-center h-screen mt-[-72px]">
                    <div className="login-page bg-white min-w-[420px] rounded-lg p-8">
                        <div className="logoContainer flex justify-center">
                            <div className="h-12 w-12">
                                <img className="companyLogo w-7" alt="Logo" src="company_logo.png" />
                            </div>
                        </div>
                        <div className="form">
                            <div className="saas-login-form flex flex-col items-center w-full">
                                <div className="loginPhrase">Silverfort Engineer Login</div>
                                <MultilineInput
                                    className="w-full mt-8"
                                    rows={4}
                                    placeholder="Login reason..."
                                    onChange={(value) => {
                                        if (value.length <= 160) {
                                            this.setState({ saasLoginComment: value });
                                        }
                                    }}
                                    value={this.state.saasLoginComment}
                                />
                                <Button
                                    text="Sign in with SSO"
                                    className="w-full [&&]:justify-center mt-6"
                                    onClick={() => this.saasSupportLoginHandler()}
                                    buttonSize={ButtonSizes.Large}
                                    disabled={!this.state.saasLoginComment}
                                />
                                {this.state.loginFailed && (
                                    <div id="error" className="shown">
                                        Invalid credentials
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;
